import Sortable from "@stimulus-components/sortable"
import { patch } from "@rails/request.js"

export class Controller extends Sortable {
  static targets = ["phase"]

  connect() {
    this.phaseMovedOver = null
    this.inFlight = false
    this.pendingMove = null
    super.connect()
  }

  onMove(evt, _originalEvent) {
    if (
      evt.related?.classList.contains("sort-filtered") &&
      evt.willInsertAfter
    ) {
      return false
    }

    if (!this.phaseTargets.includes(evt.related)) return

    const eventPhase = evt.related.dataset.phase
    const firstPhase = this.phaseTargets[0].dataset.phase

    if (eventPhase === undefined) {
      throw new Error("Missing event phase")
    }

    if (firstPhase === undefined) {
      throw new Error("Missing first phase")
    }

    if (evt.related.dataset.phase === this.phaseTargets[0].dataset.phase)
      return false

    this.phaseMovedOver = evt.related
  }

  onStart(evt) {
    this.phaseMovedOver = null
    this.currentIndex = evt.oldIndex
  }

  onUpdate({ item, newIndex }) {
    this.pendingMove = { item, newIndex }
    this.flushMoves()
  }

  async flushMoves() {
    if (this.inFlight) return

    this.inFlight = true

    try {
      while (this.pendingMove) {
        const { item, newIndex } = this.pendingMove
        this.pendingMove = null

        const response = await patch(item.dataset.sortableUpdateUrl, {
          body: this._formData(item, newIndex),
          responseKind: this.responseKindValue,
        })

        if (!response.ok) {
          this.resync()
          return
        }
      }
    } catch (error) {
      console.error("Failed to reorder ingredient", error)
      this.resync()
    } finally {
      this.inFlight = false
    }
  }

  resync() {
    this.pendingMove = null

    const frame = this.element.closest("turbo-frame")

    if (frame) {
      frame.reload()
    } else {
      window.location.reload()
    }
  }

  _attributeName(name) {
    return this.resourceNameValue ? `${this.resourceNameValue}[${name}]` : name
  }

  _formData(_item, newIndex) {
    const data = new FormData()
    // We need to adjust the position in two ways:
    // 1. We need to adjust the index to be 1-based instead of 0-based
    let adjustedPosition = newIndex + 1

    data.append(this._attributeName("position"), adjustedPosition)

    return data
  }

  get defaultOptions() {
    return {
      onStart: this.onStart.bind(this),
      onMove: this.onMove.bind(this),
      filter: "sort-filtered",
      preventOnFilter: true,
      scroll: true,
      scrollSensitivity: 200,
      scrollSpeed: 30,
      bubbleScroll: true,
    }
  }
}
